export const STATSIG_EVENT_NAMES = {
    CHECKOUT_ALL_ABANDON_ORDER_CLICK: 'Checkout - All - Click - Abandon Order',
    CHECKOUT_ALL_CART_SUMMARY_CLICK: 'Checkout - All - Click - Cart Summary',
    CHECKOUT_ALL_SUCCESS_ABANDON_ORDER:
        'Checkout - All - Sucsess - Abandon Order',
    CHECKOUT_STEP_END_CHECKOUT_FORM_VIEW:
        'Checkout - Checkout Step - View - End Checkout Form',
    CHECKOUT_STEP_ORDER_SUCCESS:
        'Checkout - Checkout Step - Success - Place Order',
    CHECKOUT_STEP_PAGE_VIEW: 'Checkout - Checkout Step - View - Page',
    CHECKOUT_STEP_PAYMENT_SELECTION_CLICK:
        'Checkout - Checkout Step - Click - Payment Selection',
    CHECKOUT_STEP_PLACE_ORDER_CLICK:
        'Checkout - Checkout Step - Click - Place Order',
    CHECKOUT_STEP_TRUST_MESSAGE_VIEW:
        'Checkout - Checkout Step - View - Trust Message',
    TICKET_STEP_PAGE_VIEW: 'Checkout - Ticket Selection Step - View - Page',
    TICKET_STEP_CONTINUE_TO_PAYMENT_CLICK:
        'Checkout - Ticket Selection Step - Click - Continue to payment',
    LOGIN_STEP_PAGE_VIEW: 'Checkout - Login Step - View - Page',
    LOGIN_STEP_SUCCESS_LOGIN: 'Checkout - Login Step - Success - Button Login',
};

export enum TrustMessageText {
    NO_MESSAGE = 'no_message',
    VARIANT_TRANSACTION_SAFE = 'transactions_safe',
    VARIANT_PEOPLE_SECURELY_ORDER = 'people_securely_order',
}

export const TRUST_MESSAGE_EXPERIMENT = {
    defaultValue: TrustMessageText.NO_MESSAGE,
    name: 'checkout_trust_message',
    param: 'trust_message_copy',
};

export const EXPRESS_CHECKOUT_EXPERIMENT = {
    defaultValue: false,
    name: 'checkout_-_add_express_checkout',
    param: 'has_apple_pay_in_ticket_page',
};

export const SIMPLIFY_CART_SUMMARY_BUTTON_EXPERIMENT = {
    defaultValue: false,
    name: 'checkout_simplify_cart_summary_button',
    param: 'use_simplified_cart_summary_button',
};

export const SORT_AVAILABLE_TICKETS_FIRST_EXPERIMENT = {
    defaultValue: true,
    name: 'checkout_sort_available_tickets_first',
    param: 'available_tickets_first',
};

export const CONTINUE_TO_PAYMENT_CTA_EXPERIMENT = {
    defaultValue: false,
    name: 'checkout_continue_to_payment_cta',
    param: 'use_continue_to_payment_cta',
};
